import React, {memo} from 'react';
import { Box } from '@mui/material';
import util from '../../util';
import PieChart from '../../components/common/charts/PieChart';
import ColumnChart from '../../components/common/charts/ColumnChart';
import StackedBarChart from '../../components/common/charts/StackedBarChart';



const StackedChart = ({ config, data, hideLegend, yAxisLabel, xAxisLabel, label, labelProps, width='100%', height = 420 }) => {
	


	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			{/* ----Column Charts--- */}
			{config.selectedChartType === 'Column' && (
				<ColumnChart
					data={data}
					labelProps={labelProps}
					hideLegend={hideLegend}
					yAxisLabel={yAxisLabel}
					xAxisLabel={xAxisLabel}
					width={width}
					height={height}
				></ColumnChart>
			)}

			{/* Pie Charts */}
			{['PieChart', 'Pie'].includes(config.selectedChartType) && (
				<PieChart
					data={data}
					label={label}
					labelProps={labelProps}
					hideLegend={hideLegend}
					width={width}
					height={height}
				/>
			)}

			{/* ----Stacked Charts--- */}
			{config.selectedChartType === 'Stacked' && (
				<StackedBarChart
					data={data}
					labelProps={labelProps}
					hideLegend={hideLegend}
					yAxisLabel={yAxisLabel}
					xAxisLabel={xAxisLabel}
					width={width}
					height={height}
				/>
			)}
		</Box>
	);
};
export default memo(StackedChart, (props, nextProps) =>
	util.deepEqual([props.data, props.config, props.label], [nextProps.data, nextProps.config, nextProps.label])
);